import { XYAxisMapper } from '../types/axis.js';
import { isCategorical } from '../types/guards.js';
import type { ChartInteractionsInternal } from '../types/xy-chart-internals.js';
import type { XYChartXAxisProps } from '../types/xy-chart.js';

export const interactionsFor = (axis: XYChartXAxisProps) => {
  if (isCategorical(XYAxisMapper[axis.type])) {
    return {
      zoom: false,
      pan: false,
      infinite: false,
    };
  }

  return {
    zoom: !axis.disableZoom,
    pan: !axis.disablePan,
    infinite: !!axis.infiniteZoom,
    initial: axis.initialZoom,
    current: axis.currentZoom,
  };
};

export const isZoomEnabledFor = (axis: {
  interactions: ChartInteractionsInternal;
}) => {
  return axis.interactions.zoom;
};

export const isPanEnabledFor = (axis: {
  interactions: ChartInteractionsInternal;
}) => {
  return axis.interactions.pan;
};

export const isInfiniteZoomEnabledFor = (axis: {
  interactions: ChartInteractionsInternal;
}) => {
  return axis.interactions.infinite;
};
